import React from "react";
import { motion } from "motion/react";
import { CheckCircle, XCircle, Home, ArrowRight, RefreshCw } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const status = query.get("status");
  const isFailed = status === "failed";
 
  console .log ("url params:", location.search);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`flex items-center justify-center min-h-screen px-4 py-12 bg-gradient-to-br ${
        isFailed ? "from-red-50 via-orange-50 to-red-50" : "from-red-50 via-blue-50 to-red-50"
      }`}
    >
      <div className="w-full max-w-lg">
        {/* Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 200 }}
          className="flex justify-center mb-6"
        >
          <div
            className={`flex items-center justify-center w-24 h-24 rounded-full shadow-lg bg-gradient-to-r ${
              isFailed ? "from-red-500 to-red-600" : "from-green-600 to-green-700"
            }`}
          >
            {isFailed ? (
              <XCircle className="w-12 h-12 text-white" />
            ) : (
              <CheckCircle className="w-12 h-12 text-white" />
            )}
          </div>
        </motion.div>

        {/* Heading */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25 }}
          className="mb-3 text-3xl font-bold text-center text-gray-800"
        >
          {isFailed ? "Payment Failed" : "Payment Successful!"}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35 }}
          className="mb-8 text-base text-center text-gray-600"
        >
          {isFailed
            ? "Your payment could not be completed. Please try again or contact support if the issue persists."
            : "Your top-up was processed successfully. Your units will be credited shortly."}
        </motion.p>

        {/* Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45 }}
          className="flex flex-col gap-3 sm:flex-row sm:justify-center"
        >
          {isFailed ? (
            <>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate("/subscription-plans")}
                className="flex items-center justify-center gap-2 px-8 py-3 font-semibold text-white bg-gradient-to-r from-red-600 to-red-700 rounded-xl shadow-md transition-all duration-300 hover:shadow-lg"
              >
                <RefreshCw className="w-5 h-5" />
                Try Again
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate("/home")}
                className="flex items-center justify-center gap-2 px-8 py-3 font-semibold text-red-600 bg-white rounded-xl border-2 border-red-600 transition-all duration-300 hover:bg-red-50"
              >
                <Home className="w-5 h-5" />
                Go to Dashboard
              </motion.button>
            </>
          ) : (
            <>
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate("/home")}
                className="flex items-center justify-center gap-2 px-8 py-3 font-semibold text-white bg-gradient-to-r from-red-600 to-red-700 rounded-xl shadow-md transition-all duration-300 hover:shadow-lg"
              >
                <Home className="w-5 h-5" />
                Go to Dashboard
              </motion.button>

              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => navigate("/quick-sms")}
                className="flex items-center justify-center gap-2 px-8 py-3 font-semibold text-red-600 bg-white rounded-xl border-2 border-red-600 transition-all duration-300 hover:bg-red-50"
              >
                <ArrowRight className="w-5 h-5" />
                Start Messaging
              </motion.button>
            </>
          )}
        </motion.div>

        {/* Support note */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-10 p-5 bg-white rounded-xl border border-gray-200 shadow-sm text-center"
        >
          <p className="text-sm font-medium text-gray-700 mb-1">Need Help?</p>
          <p className="text-xs text-gray-500">
            Our support team is available 24/7 to assist you with any questions.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default PaymentSuccess;
